export enum FileUploadState {
  DEFAULT = 'default',
  DISABLED = 'disabled',
  HOVER = 'hover',
  DRAG = 'drag',
  ERROR = 'error'
}

export enum FileUploadVariant {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical'
}

export enum FileUploadError {
  INVALID_FORMAT = "Invalid file format! Upload valid file.",
  SIZE_LIMIT_EXCEEDED = "File exceeds size limit! Upload smaller file.",
  MULTIPLE_NOT_ALLOWED = "Please Upload Single File!",
  DUPLICATES_NOT_ALLOWED = "Duplicate Files Are Not Allowed!",
  UPLOAD_URL_REQUIRED = "Upload URL is required!",
  SERVER_SIDE_ERROR = "Error from server! Please try again later.",
  NETWORK_ERROR = "Network error! Please try again later.",
  UPLOAD_CANCELLED = "File upload cancelled."
}

export enum FileUploadEvent {
  NILE_INIT = "nile-init",
  NILE_BROWSE = "nile-browse",
  NILE_CHANGE = "nile-change",
  NILE_UPLOADING = "nile-uploading",
  NILE_UPLOAD_PROGRESS = "nile-upload-progress",
  NILE_UPLOAD_SUCCESS = "nile-upload-success",
  NILE_UPLOAD_CANCELLED = "nile-upload-cancelled",
  NILE_SIZE_EXCEED_FILES = "nile-size-exceed-files",
  NILE_CANCEL_UPLOAD = "nile-cancel-upload",
  NILE_NETWORK_ERROR = "nile-network-error",
  SERVER_SIDE_ERROR = "nile-server-error",
  NILE_DESTROY = "nile-destroy",
  NILE_ERROR = "nile-error",
}

export enum FileUploadDefaults {
  TITLE = 'Drag and drop to upload',
  SUBTITLE = 'PNG, JPG or SVG (upto 1MB) | 1:1 ratio',
  ERROR_MESSAGE = 'Invalid File Format.',
  DRAG_STATE_DEFAULT = 'Drop files here to upload',
  CUSTOM_ERROR = 'Error Occured!'
};

export enum FileUploadErrorReason {
  INVALID_FORMAT = "Invalid Format",
  SIZE_LIMIT_EXCEEDED = "Size Limit Exceeded",
  SERVER_SIDE_ERROR = "Server Side Error",
  NETWORK_ERROR = "Network Error",
  UPLOAD_CANCELLED = "Upload Cancelled"
}

export enum ErrorType {
  SERVER = "SERVER",
  NETWORK = "NETWORK",
  UPLOAD_CANCELLED = "UPLOAD_CANCELLED",
  VALIDATION = "VALIDATION",
}